'use client';

import { useState } from 'react';

const DEFAULT_SRC = '/cs/schedule-sub.svg';
const HOVER_SRC = '/cs/schedule-sub-hover.svg';
const CLICKED_SRC = '/cs/schedule-sub-clicked.svg';

type ImageState = 'default' | 'hover' | 'clicked';

export function ScheduleSubscribeButton({
  href,
  alt,
}: {
  href: string;
  alt: string;
}) {
  const [imageState, setImageState] = useState<ImageState>('default');

  const src =
    imageState === 'hover' ? HOVER_SRC : imageState === 'clicked' ? CLICKED_SRC : DEFAULT_SRC;

  return (
    <a
      className="cs-schedule-subscribe"
      href={href}
      target="_blank"
      rel="noreferrer"
      onMouseEnter={() => setImageState((current) => (current === 'clicked' ? 'clicked' : 'hover'))}
      onMouseLeave={() => setImageState((current) => (current === 'clicked' ? 'clicked' : 'default'))}
      onPointerDown={() => setImageState('clicked')}
      onPointerUp={() => setImageState((current) => (current === 'clicked' ? 'hover' : current))}
      onPointerLeave={() => setImageState('default')}
      onPointerCancel={() => setImageState('default')}
    >
      <img src={src} alt="" />
      <span className="cs-schedule-subscribe-label">{alt}</span>
    </a>
  );
}
